<template>
    <div>
        <b-row class="sup">
            <b-col cols="12">
                <b-card class="text-center">
                    <template slot="header" class="reportesheader">
                        <b-row>
                            <b-col cols="1" sm="2"	md="2"	lg="2"	xl="1">
                                <b-form-select class="reporteOpciones" v-model="selected" :options="options"/>
                            </b-col>
                            <b-col cols="1" sm="2"	md="10"	lg="2"	xl="6">
                                <template v-for="(item, index) in filtros">
                                    <template v-if="selected === 1">
                                        <b-btn :key="index" size="sm" variant="outline-success" class="m-1" @click="addFilter(item)">{{item.text}}</b-btn>
                                    </template>
                                    <template v-else>
                                        <b-btn v-if="item.value !== 10" :key="index" size="sm" variant="outline-success" class="m-1" @click="addFilter(item)">{{item.text}}</b-btn>
                                    </template>
                                </template>  
                            </b-col>
                            <b-col cols="1" sm="2"	md="10"	lg="2"	xl="4" >
                                <b-form inline>
                                    Desde: <b-input type="date" v-model="f1"/>
                                    Hasta: <b-input type="date" v-model="f2"/>
                                    <b-button size="sm" class="ml-4" @click="selectorLista()" :disabled="validateFilters()" variant="success"><i class="fa fa-search"/> Buscar</b-button>
                                </b-form>
                            </b-col>
                            <b-col cols="1" sm="2"	md="1"	lg="2"	xl="1" v-if="this.emitidorecibido===0">
                                <b-button size="sm" v-if="!loadingexcelreport" variant="warning" :disabled="!Boolean(f1!=='' && f2!=='')" @click="downloadReportExcel()">
                                    <i class="fa fa-file-excel"/> Exportar
                                </b-button>
                                <b-button v-else variant="secondary"><i class="fa fa-spin fa-spinner"/> Procesando</b-button>
                            </b-col>  
                        </b-row>
                    </template>
                    <b-row> 
                        <b-col cols="1" sm="2"	md="12"	lg="2"	xl="9">
                            <template>
                                <h5>
                                    <b-badge v-for="(item, index) in filters" :key="index" pill variant="secondary" class="mr-2 badgepersonalizado">
                                        <b-input-group>
                                            <h6 class="titlefilter">{{item.name}}</h6>
                                            <template v-if="item.type === 7 || item.type === 8 || item.type === 9 || item.type === 10 || item.type === 11"/>
                                            <!-- <template v-else-if="item.type === 10">
                                                <b-input-group style="width:200px">
                                                    <template #prepend>
                                                        <b-input-group-text class="filtropersonalizado">Desde</b-input-group-text>
                                                        </template>
                                                    <b-form-input type="number" v-model="rango1" class="filtropersonalizado" @keyup.enter="selectorLista()"></b-form-input>                                       
                                                </b-input-group>
                                                <b-input-group style="width:200px">
                                                    <template #prepend>
                                                        <b-input-group-text class="filtropersonalizado">Hasta</b-input-group-text>
                                                        </template>
                                                    <b-form-input type="number" v-model="rango2" class="filtropersonalizado" @keyup.enter="selectorLista()"></b-form-input>                                              
                                                </b-input-group>
                                            </template> -->
                                            <template v-else>
                                                <b-form-input size="sm" class="filtropersonalizado" v-model="item.value" @keyup.enter="selectorLista()"/>
                                            </template>
                                            <b-input-group-append>
                                                <i @click="removeFilter(index)" class="fa fa-times btnremove"/>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-badge>
                                </h5>
                            </template>
                        </b-col>    
                        <b-col cols="1" sm="2"	md="2"	lg="2"	xl="3">
                            <!-- <b-nav-form> -->
                                <!-- <b-form-input size="sm" class="mr-sm-2" type="text" placeholder="Búsqueda General" v-model="tablefilter"/> -->
                                <!-- <b-button size="sm" class="my-2 my-sm-0" @click="selectorLista()" :disabled="validateFilters()" variant="success" type="submit"><i class="fa fa-search"/> Buscar</b-button> -->
                            <!-- </b-nav-form> -->
                        </b-col>            
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                <b-card>
                    <div v-if="cargando">
                    <div class="row">
                        <div class="col-md-12 text-center">
                            <h3>Cargando <i class="fa fa-spin fa-spinner"/></h3>
                        </div>
                    </div>
                    </div>
                    <div v-else>
                        <b-row>
                            <b-col cols="1" sm="2"	md="4"	lg="4"	xl="2">
                                <b-form-group label-cols="3" label="Orden" class="mb-0">
                                    <b-input-group>
                                        <b-form-select v-model="orden" slot="append" @input="selectorLista">
                                            <option :value="'asc'">Más Antiguo</option>
                                            <option :value="'desc'">Más Reciente</option>
                                        </b-form-select>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="1" sm="2"	md="4"	lg="4"	xl="2">
                                <b-form-group label-cols="3" label="Mostrar" class="mb-0">
                                    <b-input-group>
                                        <b-form-select v-model="limite" slot="append" @input="selectorLista">
                                            <option :value="10">10</option>
                                            <option :value="25">25</option>
                                            <option :value="50">50</option>
                                            <option :value="100">100</option>
                                        </b-form-select>                            
                                    </b-input-group>                        
                                </b-form-group>                    
                            </b-col>
                            <b-col v-if="rutaanticipos == 3" cols="1" sm="2"	md="2"	lg="4"	xl="2">
                                <div class="col-md-12 text-center">
                                    <b-button variant="secondary" @click="globalFactoring"><i class="fa fa-sync-alt"/> </b-button>
                                </div>
                            </b-col>
                            <b-col v-else cols="1" sm="2"	md="4"	lg="4"	xl="2">
                                <div class="col-md-12 text-center">
                                    <b-button variant="secondary" @click="selectorLista"><i class="fa fa-sync-alt"/> </b-button>
                                </div>
                            </b-col>
                        </b-row>
                        <br>
                        <b-table v-if="rutaanticipos == 1"
                            responsive 
                            :small="small"
                            :striped="striped"
                            :outlined="outlined"
                            :items="principal"
                            :fields="invoices_final_fields"
                            :current-page="pactual"
                            :per-page="limite"                   
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            :sort-direction="sortDirection"
                            :filter="tablefilter"
                            >
                            <template slot="creditoFac" slot-scope="row"> 
                                <template v-if="row.item.credito !=null">
                                    <template v-if="row.item.pagado == 0">
                                      <i title="Factura a crédito por pagar" class="fa fa-copyright text-danger"></i>
                                    </template>
                                    <template v-if="row.item.pagado == 1">
                                        <i title="Factura a crédito pagada" class="fa fa-copyright text-success"></i>        
                                    </template>
                                </template>
                            </template>
                            <template slot="estado" slot-scope="row">
                                <div class="text-center">
                                    <template v-if="row.item.emitido===1 && row.item.baja===1">
                                        <div><span class="badge badge-dark">Baja <i class="fa fa-ban"/></span></div>
                                    </template>
                                    <template v-else-if="row.item.emitido===3 && row.item.baja===0">
                                        <div><span class="badge badge-info">Baja pendiente <i class="fa fa-ban"/></span></div>
                                    </template>
                                    <template v-else>
                                        <div v-if="row.item.emitido===1"><span class="badge badge-success">Emitido <i class="fa fa-check"/></span></div>
                                        <div v-else-if="row.item.emitido===0 && selected === 2"><span class="badge badge-warning" title="Las boletas se evian al final del día">Por Enviar <i class="fa fa-hourglass-half"/></span></div>
                                        <div v-else-if="row.item.emitido===0"><span class="badge badge-warning">Procesando <i class="fa fa-spin fa-spinner"/></span></div>
                                        <div v-else-if="row.item.emitido===2"><span class="badge badge-danger">Rechazado <i class="fa fa-times"/></span></div>
                                        <div v-else-if="row.item.emitido===8"><span class="badge badge-danger">En consulta <i class="fa fa-clock" aria-hidden="true"></i></span></div>
                                    </template>
                                </div>
                                <div class="">
                                <template v-if="row.item.estado === '1'"><span class="badge badge-success">Emitido <i class="fa fa-check"/></span></template>
                                <template v-if="row.item.estado === '2'"><span class="badge badge-dark">Baja <i class="fa fa-ban"/></span></template>
                                </div>
                            </template>
                            <template slot="usuario" slot-scope="row">
                                <template v-if="emitidorecibido === 0">
                                    <template v-if="row.item.receiver && row.item.receiver.tipo != 0">
                                        {{row.item.receiver.idReceptor}} - {{row.item.receiver.razonSocial}}
                                    </template>
                                    <template v-else-if="row.item.proforma && row.item.proforma.receptor.tipo != 0">
                                        {{row.item.proforma.receptor.nro}} - {{row.item.proforma.receptor.razonSocial}}
                                    </template>
                                    <template v-else-if="row.item.ordenCompra && row.item.ordenCompra.receptor.tipo != 0">
                                        {{row.item.ordenCompra.receptor.nro}} - {{row.item.ordenCompra.receptor.razonSocial}}
                                    </template>
                                    <template v-else>
                                        <template v-if="row.item.adicional && row.item.adicional.otroNombre" >
                                            {{row.item.adicional.otroNombre}}
                                        </template>
                                        <template v-else>
                                              P&uacute;blico en General
                                        </template>
                                    </template>                 
                                </template>
                                <template v-else-if="emitidorecibido === 1">
                                    {{row.item.emitter.idEmisor}} - {{row.item.emitter.razonSocial}}
                                </template>
                                <template v-else>
                                    {{row.item}} - {{row.item}}
                                </template>
                            </template>
                            <template slot="emisor" slot-scope="row">
                                <template v-if="row.item && row.item.adicional && row.item.adicional !=''">
                                    {{row.item.adicional.username}}
                                </template>
                                <template v-else-if="row.item.notaVenta && row.item.notaVenta.adicional && row.item.notaVenta.adicional.username!=''">
                                    {{row.item.notaVenta.adicional.username}}
                                </template>
                                <template v-else-if="row.item.ordenCompra && row.item.ordenCompra.adicional && row.item.ordenCompra.adicional.username!=''">
                                    {{row.item.ordenCompra.adicional.username}}
                                </template>
                                <template v-else-if="row.item.proforma && row.item.proforma.adicional && row.item.proforma.adicional.username!=''">
                                    {{row.item.proforma.adicional.username}}
                                </template>
                            </template>   
                            <template slot="emision" slot-scope="row">
                                <template v-if="row.item.fechaEmision && row.item.fechaEmision !=''">
                                    {{ row.item.fechaEmision | moment('D/M/Y hh:mm:ss A') }} 
                                </template>
                                <template v-else>
                                    {{ row.item.created_at | moment('D/M/Y hh:mm:ss A') }} 
                                </template>
                            </template>
                            <template slot="moneda" slot-scope="row">
                                <template v-if="row.item.tipoMoneda && row.item.tipoMoneda !=''">
                                    <div class="text-right">
                                        <template v-if="row.item.tipoMoneda==='PEN'">S/</template>
                                        <template v-else-if="row.item.tipoMoneda==='USD'">$</template>
                                        <template v-else>{{ row.item.tipoMoneda }}</template>                                                                  
                                                {{row.item.importeTotal}}
                                    </div>
                                </template>
                                <template v-else-if="row.item.notaVenta && row.item.notaVenta.moneda && row.item.notaVenta.moneda.simbolo !=''">
                                    <div v-if="row.item.notaVenta && row.item.notaVenta.totales && row.item.notaVenta.totales.importeTotal">
                                        <template>{{ row.item.notaVenta.moneda.simbolo }}</template>                                                                  
                                                {{(row.item.notaVenta.totales.importeTotal).toFixed(2)}}
                                    </div>
                                </template> 
                                <template v-else-if="row.item.proforma && row.item.proforma.moneda && row.item.proforma.moneda.simbolo !=''">
                                    <div v-if="row.item.proforma && row.item.proforma.totales && row.item.proforma.totales.importeTotal">
                                        <template>{{ row.item.proforma.moneda.simbolo }}</template>                                                                  
                                                {{parseFloat(row.item.proforma.totales.importeTotal).toFixed(2)}}
                                    </div>
                                </template>
                                <template v-else-if="row.item.ordenCompra && row.item.ordenCompra.moneda && row.item.ordenCompra.moneda.simbolo !=''">
                                    <div v-if="row.item.ordenCompra && row.item.ordenCompra.totales && row.item.ordenCompra.totales.importeTotal">
                                        <template>{{ row.item.ordenCompra.moneda.simbolo }}</template>                                                                  
                                                {{(row.item.ordenCompra.totales.importeTotal).toFixed(2)}}
                                    </div>
                                </template>  
                            </template>                      
                            <template slot="acciones" slot-scope="row">
                                <template v-if="row.item.emitido!==2 && row.item.baja!==1 && row.item.estado!=2" >
                                        <b-button-group>
                                            <button v-show="!row.item.loading" type="button" class="btn" size="sm" @click="mostrarDetalles(row, row.index)" title="Mas opciones">
                                            <template v-if="!row.item.mostrardetalles">
                                                <i class="fa fa-plus"/>
                                            </template>
                                            <template v-else>
                                                <i class="fa fa-minus"/>
                                            </template>
                                        </button>
                                        <b-button size="sm" v-show="row.item.loading" variant="ligth"><i
                                                class="fa fa-spin fa-spinner"/></b-button>
                                        <b-button v-b-modal.prevmodal @click="viewPdf(row.item)"><i class="fa fa-tv"
                                                                                                    v-b-tooltip.hover
                                                                                                    title="Vista Previa"/></b-button>
                                        <template v-if="selected !=6 && selected !=8 && selected !=9">
                                        <b-button @click="downloadPdf(row.item)"><i class="fa fa-file-pdf"
                                                                                    v-b-tooltip.hover
                                                                                    title="Descargar PDF"/></b-button>
                                        </template>
                                        <b-button  @click="setInvoice(row.item)" v-b-modal.modal1>
                                            <i class="fa fa-share-alt" v-b-tooltip.hover title="Compartir Documento" aria-hidden="true"></i>
                                        </b-button>
                                        <template v-if="selected !=6 && selected !=8 && selected !=9">
                                        <b-button v-if="row.item.emitido===0" class="disabled" :disabled="true"><i
                                                class="fa fa-file-archive" v-b-tooltip.hover title="Descargar CDR"/></b-button>
                                        <b-button v-else @click="downloadCdr(row.item)"><i class="fa fa-file-archive"
                                                                                           v-b-tooltip.hover
                                                                                           title="Descargar CDR"/></b-button>
                                        <b-button v-if="row.item.emitido===0" class="disabled" :disabled="true"><i
                                                class="fa fa-file-code" v-b-tooltip.hover title="Descargar XMLx"/></b-button>
                                        <b-button v-else @click="downloadXml(row.item)"><i class="fa fa-file-code"
                                                                                           v-b-tooltip.hover
                                                                                           title="Descargar XMLx"/></b-button>
                                        <template v-if="emitidorecibido===0">
                                            <b-button v-b-tooltip.hover variant="primary" v-if="selected===1 || selected===2" @click="advertConvertCredit(row.item)">
                                                <i title="Convertir a crédito" class="fa fa-handshake text-white"/></b-button>
                                            <b-button v-if="row.item.emitido===0 || row.item.baja===1" v-show="selected == 1" :disabled="true" class="disabled btn btn-danger">
                                                <i class="fa fa-trash text-white" v-b-tooltip.hover
                                                   title="Baja de Factura"/></b-button>
                                                 <!--experimento de title no emitidas-->
                                                 <b-button v-if="row.item.emitido===0 || row.item.baja===2" v-show="selected == 2" :disabled="true" class="disabled btn btn-danger">
                                                <i class="fa fa-trash text-white" v-b-tooltip.hover
                                                   title="Baja de Boleta"/></b-button>
                                                   <b-button v-if="row.item.emitido===0 || row.item.baja===3" v-show="selected == 3" :disabled="true" class="disabled btn btn-danger">
                                                <i class="fa fa-trash text-white" v-b-tooltip.hover
                                                   title="Baja de N.Credito"/></b-button> 
                                                   <b-button v-if="row.item.emitido===0 || row.item.baja===4" v-show="selected == 4" :disabled="true" class="disabled btn btn-danger">
                                                <i class="fa fa-trash text-white" v-b-tooltip.hover
                                                   title="Baja de N.Debito"/></b-button>
                                                <!-- fin experimento no emititas-->
                                            <b-button v-else-if="selected == 1" @click="preBaja(row.item)" class="btn btn-danger">
                                                <i class="fa fa-trash text-white" v-b-tooltip.hover
                                                   title="Baja de Factura"/></b-button>
                                                <!--experim. 2 title de emitidas-->
                                                <b-button v-else-if="selected == 2" @click="preBaja(row.item)" class="btn btn-danger">
                                                <i class="fa fa-trash text-white" v-b-tooltip.hover
                                                   title="Baja de Boleta"/></b-button>
                                                   <b-button v-else-if="selected == 3" @click="preBaja(row.item)" class="btn btn-danger">
                                                <i class="fa fa-trash text-white" v-b-tooltip.hover
                                                   title="Baja de N.Credito"/></b-button>
                                                   <b-button v-else-if="selected == 4" @click="preBaja(row.item)" class="btn btn-danger">
                                                <i class="fa fa-trash text-white" v-b-tooltip.hover
                                                   title="Baja de N.Debito"/></b-button>
                                                <!-- fin experimento emitidas-->
                                        </template>
                                        </template>
                                    </b-button-group>
                                </template>
                                <template v-else>
                                <b-button-group>
                                    <template v-if="selected !=6">
                                    <button v-show="!row.item.loading" type="button" class="btn" size="sm" @click="mostrarDetalles(row, row.index)" title="Mas opciones">
                                        <template v-if="!row.item.mostrardetalles">
                                            <i class="fa fa-plus"/>
                                        </template>
                                        <template v-else>
                                                <i class="fa fa-minus"/>
                                        </template>
                                    </button>
                                    <b-button size="sm" v-show="row.item.loading" variant="ligth"><i
                                        class="fa fa-spin fa-spinner"/>
                                    </b-button>
                                    <b-button @click="downloadCdr(row.item)" title="Descargar CDR"><i class="fa fa-file-archive"/></b-button>
                                    <b-button v-if="row.item.emitido===2" @click="estadoEmision(row.item)" v-b-modal.motivorechazo8 v-b-tooltip.hover title="Estado de la emision" class="btn" variant = "primary">
                                        <i class="fa fa-eye text-white"/></b-button>
                                    </template>
                                </b-button-group>
                            </template>
                            </template>
                            <template slot="row-details" slot-scope="row">
                                <b-card class="tamanioletra">
                                    <template v-if="selected !=6 && selected !=8 && selected !=9">
                                    <b-table striped hover :items="row.item.lista" :fields="listaitems_fields" :busy="row.item.loading">
                                        <div slot="table-busy" class="text-center text-danger my-2">
                                            <b-spinner class="align-middle"/>
                                            <strong> Cargando...</strong>
                                        </div>
                                        <template slot="index" slot-scope="row">
                                            {{ row.index+1 }}
                                        </template>
                                        <template slot="codigoItem" slot-scope="row">
                                            <div v-if="selected != 5">
                                                {{row.item.codigoProducto}}
                                            </div>
                                            <div v-else-if=" selected == 5">
                                                {{row.item.codigoItem}}
                                            </div>
                                        </template>
                                        <template slot="UniMedItem" slot-scope="row"> 
                                            <div v-if="selected != 5">
                                                {{row.item.unidadMedidaCantidad}}
                                            </div>
                                            <div v-else-if=" selected == 5">
                                                {{row.item.unidadMedida}}
                                            </div>
                                        </template>
                                        <template slot="cantidad" slot-scope="row">
                                            <div>
                                                {{ Number.parseFloat(row.item.cantidad).toFixed(2) }}
                                            </div>
                                        </template>
                                            <template slot="precioVentaUnitario" slot-scope="row">
                                                <template v-if="selected != 5">
                                                    <div>
                                                        <template v-if="row.item.moneda==='PEN'">S/</template>
                                                        <template v-else-if="row.item.moneda==='USD'">$</template>
                                                        <template v-else>{{ row.item.moneda }}</template>
                                                        <template v-if="row.item.precioVentaUnitario">
                                                            {{ Number.parseFloat(row.item.precioVentaUnitario).toFixed(2) }}
                                                        </template>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                   0.00
                                                </template>
                                            </template>
                                        <template slot="descuento" slot-scope="row">
                                            <div>
                                                <template v-if="row.item.moneda==='PEN'">S/</template>
                                                <template v-else-if="row.item.moneda==='USD'">$</template>
                                                <template v-else>{{ row.item.moneda }}</template>
                                                <template v-if="row.item.descuento">
                                                    {{ Number.parseFloat(row.item.descuento).toFixed(2) }}
                                                </template>
                                                <template v-else>
                                                    0.00
                                                </template>
                                            </div>
                                        </template>     
                                        <template slot="valorVenta" slot-scope="row">
                                            <template v-if="selected != 5">
                                                <div>
                                                    <template v-if="row.item.moneda==='PEN'">S/</template>
                                                    <template v-else-if="row.item.moneda==='USD'">$</template>
                                                    <template v-else>{{ row.item.moneda }}</template>
                                                    <template v-if="row.item.valorVenta">
                                                        {{ Number.parseFloat(row.item.valorVenta).toFixed(2) }}
                                                    </template>
                                                </div>
                                            </template>
                                            <template v-else>0.00</template>    
                                        </template>
                                    </b-table>
                                    </template>
                                    <!-- separaciom NV -->
                                    <template v-else-if="selected == 6">
                                    <b-table striped hover :items="row.item.notaVenta.items" :fields="listaitems_fields" :busy="row.item.loading">
                                        <div slot="table-busy" class="text-center text-danger my-2">
                                            <b-spinner class="align-middle"/>
                                            <strong> Cargando...</strong>
                                        </div>
                                        <template slot="index" slot-scope="row">
                                            {{ row.index+1 }}
                                        </template>
                                        <template slot="codigoItem" slot-scope="row">
                                            <div v-if="selected != 5">
                                                {{row.item.codigoProducto}}
                                            </div>
                                            <div v-else-if=" selected == 5">
                                                {{row.item.codigoItem}}
                                            </div>
                                        </template>
                                        <template slot="UniMedItem" slot-scope="row"> 
                                            <div v-if="selected != 5">
                                                {{row.item.unidadMedidaCantidad}}
                                            </div>
                                            <div v-else-if=" selected == 5">
                                                {{row.item.unidadMedida}}
                                            </div>
                                        </template>
                                        <template slot="cantidad" slot-scope="row">
                                            <div>
                                                {{ Number.parseFloat(row.item.cantidad).toFixed(2) }}
                                            </div>
                                        </template>
                                            <template slot="precioVentaUnitario" slot-scope="row">
                                                <template v-if="selected != 5">
                                                    <div>
                                                        <template v-if="row.item.moneda==='PEN'">S/</template>
                                                        <template v-else-if="row.item.moneda==='USD'">$</template>
                                                        <template v-else>{{ row.item.moneda }}</template>
                                                        <template v-if="row.item.precioVentaUnitario">
                                                            {{ Number.parseFloat(row.item.precioVentaUnitario).toFixed(2) }}
                                                        </template>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                   0.00
                                                </template>
                                            </template>
                                        <template slot="descuento" slot-scope="row">
                                            <div>
                                                <template v-if="row.item.moneda==='PEN'">S/</template>
                                                <template v-else-if="row.item.moneda==='USD'">$</template>
                                                <template v-else>{{ row.item.moneda }}</template>
                                                <template v-if="row.item.descuento">
                                                    {{ Number.parseFloat(row.item.descuento).toFixed(2) }}
                                                </template>
                                                <template v-else>
                                                    0.00
                                                </template>
                                            </div>
                                        </template>     
                                        <template slot="valorVenta" slot-scope="row">
                                            <template v-if="selected != 5">
                                                <div>
                                                    <template v-if="row.item.moneda==='PEN'">S/</template>
                                                    <template v-else-if="row.item.moneda==='USD'">$</template>
                                                    <template v-else>{{ row.item.moneda }}</template>
                                                    <template v-if="row.item.valorVenta">
                                                        {{ Number.parseFloat(row.item.valorVenta).toFixed(2) }}
                                                    </template>
                                                </div>
                                            </template>
                                            <template v-else>0.00</template>    
                                        </template>
                                    </b-table>
                                    </template>
                                    <!-- proforma -->
                                    <template v-else-if="selected == 8">
                                    <b-table striped hover :items="row.item.proforma.items" :fields="listaitems_fieldsProforma">
                                        <div slot="table-busy" class="text-center text-danger my-2">
                                            <b-spinner class="align-middle"/>
                                            <strong> Cargando...</strong>
                                        </div>
                                        <template slot="index" slot-scope="row">
                                            {{ row.index+1 }}
                                        </template>
                                        <template slot="codigoItem" slot-scope="row">
                                            <div v-if="selected != 5">
                                                {{row.item.codigoProducto}}
                                            </div>
                                            <div v-else-if=" selected == 5">
                                                {{row.item.codigoItem}}
                                            </div>
                                        </template>
                                        <template slot="UniMedItem" slot-scope="row"> 
                                            <div v-if="selected != 5">
                                                {{row.item.unidadMedidaCantidad}}
                                            </div>
                                            <div v-else-if=" selected == 5">
                                                {{row.item.unidadMedida}}
                                            </div>
                                        </template>
                                        <template slot="cantidad" slot-scope="row">
                                            <div>
                                                {{ Number.parseFloat(row.item.cantidad).toFixed(2) }}
                                            </div>
                                        </template>
                                            <template slot="precioVentaUnitario" slot-scope="row">
                                                <template v-if="selected != 5">
                                                    <div>
                                                        <template v-if="row.item.moneda==='PEN'">S/</template>
                                                        <template v-else-if="row.item.moneda==='USD'">$</template>
                                                        <template v-else>{{ row.item.moneda }}</template>
                                                        <template v-if="row.item.precioVentaUnitario">
                                                            {{ Number.parseFloat(row.item.precioVentaUnitario).toFixed(2) }}
                                                        </template>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                   0.00
                                                </template>
                                            </template>
                                        <template slot="descuento" slot-scope="row">
                                            <div>
                                                <template v-if="row.item.moneda==='PEN'">S/</template>
                                                <template v-else-if="row.item.moneda==='USD'">$</template>
                                                <template v-else>{{ row.item.moneda }}</template>
                                                <template v-if="row.item.descuento">
                                                    {{ Number.parseFloat(row.item.descuento).toFixed(2) }}
                                                </template>
                                                <template v-else>
                                                    0.00
                                                </template>
                                            </div>
                                        </template>     
                                        <template slot="valorVenta" slot-scope="row">
                                            <template v-if="selected != 5">
                                                <div>
                                                    <template v-if="row.item.moneda==='PEN'">S/</template>
                                                    <template v-else-if="row.item.moneda==='USD'">$</template>
                                                    <template v-else>{{ row.item.moneda }}</template>
                                                    <template v-if="row.item.valorVenta">
                                                        {{ Number.parseFloat(row.item.valorVenta).toFixed(2) }}
                                                    </template>
                                                </div>
                                            </template>
                                            <template v-else>0.00</template>    
                                        </template>
                                    </b-table>
                                    </template>
                                    <template v-else-if="selected == 9">
                                    <b-table striped hover :items="row.item.ordenCompra.items" :fields="listaitems_fieldsProforma">
                                        <div slot="table-busy" class="text-center text-danger my-2">
                                            <b-spinner class="align-middle"/>
                                            <strong> Cargando...</strong>
                                        </div>
                                        <template slot="index" slot-scope="row">
                                            {{ row.index+1 }}
                                        </template>
                                        <template slot="codigoItem" slot-scope="row">
                                            <div v-if="selected != 5">
                                                {{row.item.codigoProducto}}
                                            </div>
                                            <div v-else-if=" selected == 5">
                                                {{row.item.codigoItem}}
                                            </div>
                                        </template>
                                        <template slot="UniMedItem" slot-scope="row"> 
                                            <div v-if="selected != 5">
                                                {{row.item.unidadMedidaCantidad}}
                                            </div>
                                            <div v-else-if=" selected == 5">
                                                {{row.item.unidadMedida}}
                                            </div>
                                        </template>
                                        <template slot="cantidad" slot-scope="row">
                                            <div>
                                                {{ Number.parseFloat(row.item.cantidad).toFixed(2) }}
                                            </div>
                                        </template>
                                            <template slot="precioVentaUnitario" slot-scope="row">
                                                <template v-if="selected != 5">
                                                    <div>
                                                        <template v-if="row.item.moneda==='PEN'">S/</template>
                                                        <template v-else-if="row.item.moneda==='USD'">$</template>
                                                        <template v-else>{{ row.item.moneda }}</template>
                                                        <template v-if="row.item.precioVentaUnitario">
                                                            {{ Number.parseFloat(row.item.precioVentaUnitario).toFixed(2) }}
                                                        </template>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                   0.00
                                                </template>
                                            </template>
                                        <template slot="descuento" slot-scope="row">
                                            <div>
                                                <template v-if="row.item.moneda==='PEN'">S/</template>
                                                <template v-else-if="row.item.moneda==='USD'">$</template>
                                                <template v-else>{{ row.item.moneda }}</template>
                                                <template v-if="row.item.descuento">
                                                    {{ Number.parseFloat(row.item.descuento).toFixed(2) }}
                                                </template>
                                                <template v-else>
                                                    0.00
                                                </template>
                                            </div>
                                        </template>     
                                        <template slot="valorVenta" slot-scope="row">
                                            <template v-if="selected != 5">
                                                <div>
                                                    <template v-if="row.item.moneda==='PEN'">S/</template>
                                                    <template v-else-if="row.item.moneda==='USD'">$</template>
                                                    <template v-else>{{ row.item.moneda }}</template>
                                                    <template v-if="row.item.valorVenta">
                                                        {{ Number.parseFloat(row.item.valorVenta).toFixed(2) }}
                                                    </template>
                                                </div>
                                            </template>
                                            <template v-else>0.00</template>    
                                        </template>
                                    </b-table>
                                    </template>
                                </b-card>
                            </template>
                        </b-table>
                        <b-table v-else-if="rutaanticipos == 2"
                            responsive 
                            :small="small"
                            :striped="striped"
                            :outlined="outlined"
                            :items="anticipos"
                            :fields="anticipos_fields"
                            :current-page="pactual"
                            :per-page="limite"                   
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            :sort-direction="sortDirection"
                            :filter="tablefilter"
                            >
                            <template slot="estado" slot-scope="data">
                                <div class="text-center"> 
                                    <template v-if="data.item.emitido===1 && data.item.baja===1">
                                        <div><span class="badge badge-dark">Baja <i class="fa fa-ban"/></span></div>
                                    </template>
                                    <template v-else>
                                        <div v-if="data.item.emitido===1"><span class="badge badge-success">Emitido <i class="fa fa-check"/></span></div>
                                        <div v-else-if="data.item.emitido===0"><span class="badge badge-warning">Procesando <i class="fa fa-spin fa-spinner"/></span></div>
                                        <div v-else-if="data.item.emitido===2"><span class="badge badge-danger">Rechazado <i class="fa fa-times"/></span></div>
                                    </template>  
                                </div>                  
                            </template>
                            <template slot="receptor" slot-scope="data">
                                {{data.item.idReceptor}} - {{data.item.receiver.razonSocial}}
                            </template>
                            <template slot="emision" slot-scope="data">
                                {{ data.item.fechaEmision | moment('D/M/Y hh:mm:ss A') }} 
                            </template>
                            <template slot="moneda" slot-scope="data">
                                <div class="text-right">
                                    <template v-if="data.item.tipoMoneda==='PEN'">S/</template>
                                    <template v-else-if="data.item.tipoMoneda==='USD'">$</template>
                                    <template v-else>{{ data.item.tipoMoneda }}</template>                     
                                    {{data.item.importeTotal}}
                                </div>
                            </template>
                        </b-table>
                        <b-table  v-else-if="rutaanticipos == 3"
                            responsive 
                            :small="small"
                            :striped="striped"
                            :outlined="outlined"
                            :items="globalFac"
                            :fields="globalFac_fields"
                            :current-page="pactual"
                            :per-page="limite"                   
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            :sort-direction="sortDirection"
                            :filter="tablefilter"
                            >
                            <span class="badge badge-warning">Procesando <i class="fa fa-spin fa-spinner"/></span>
                            <template slot="serieNumero" slot-scope="row">
                                {{row.item.serie}} - {{row.item.numero}}
                            </template>
                            <template slot="fechaCreacion" slot-scope="data">
                                {{ data.item.created_at | moment('D-M-Y hh:mm:ss A') }} 
                            </template>
                            <template slot="emisor" slot-scope="data">
                                {{ data.item.idEmisor }} 
                            </template>
                            <template slot="estado" slot-scope="data">
                                <template>
                                    <div v-if="data.item.estado == 'En Evaluacion'">
                                        <span class="badge badge-warning"> {{ data.item.estado }} <i class="fa fa-spin fa-spinner"/></span>
                                    </div>
                                    <div v-else-if="data.item.estado == 'No Existe Documento'">
                                        <span class="badge badge-danger"> {{ data.item.estado }}</span>
                                    </div>
                                </template>
                            </template>
                            <template slot="acciones" slot-scope="row">
                                <button size="sm" @click="mostrarItems(row, row.index,row.item)" type="button" class="btn" title="Mas opciones">
                                <template v-if="!row.detailsShowing">
                                    <i class="fa fa-plus"></i>                                
                                </template>
                                <template v-else>
                                    <i class="fa fa-minus"></i>
                                </template>
                                </button>
                                <b-button-group>
                                    <b-button v-b-modal.prevmodalGF v-b-tooltip.hover @click="viewPdfGF(row.item)">
                                        <i class="fa fa-tv" v-b-tooltip.hover title="Vista Previa"/>
                                    </b-button>
                                    <b-button @click="downloadPdf(row.item)"><i class="fa fa-file-pdf" v-b-tooltip.hover title="Descargar PDF"/></b-button>
                                    <b-button @click="consultarEstado(row.item)"><i class="fa fa-paper-plane" v-b-tooltip.hover title="Estado"/></b-button>
                                </b-button-group>
                            </template>
                            <template v-slot:row-details="row">
                                <b-card>
                                    <b-table
                                        head-variant="light"
                                        responsive
                                        small
                                        :items="row.item.jsonBody"
                                        :fields="globalFacJsonBody_fields"
                                        :outlined="outlined">
                                        <template>

                                        </template>
                                    </b-table>
                                </b-card>
                            </template>
                        </b-table>
                        <!-- <b-table v-else-if="selected == 10"
                            responsive 
                            :small="small"
                            :striped="striped"
                            :outlined="outlined"
                            :items="facCredito"
                            :fields="facturas_credito_fields"
                            >
                            <template slot="creditoFac" slot-scope="data">
                                <template v-if="data.item.pagado == 0">
                                    <i title="Factura a crédito por pagar" class="fa fa-copyright text-danger"></i>
                                </template>
                                 <template v-else-if="data.item.pagado == 1">
                                    <i title="Factura a crédito pagada" class="fa fa-copyright text-success"></i>
                                </template>
                            </template>
                            <template slot="documento" slot-scope="data">
                                {{data.item.serie}}-{{data.item.numero}}
                            </template>
                            <template slot="emision" slot-scope="data"> 
                                {{ data.item.fechaEmision | moment('D/M/Y hh:mm:ss A') }} 
                            </template>
                            <template slot="vencimiento" slot-scope="data"> 
                                {{ data.item.vencimiento | moment('D/M/Y hh:mm:ss A') }} 
                            </template>
                            <template slot="receptor" slot-scope="data"> 
                                {{data.item.idReceptor}} - {{data.item.receiver.razonSocial}}
                            </template>
                            <template slot="importeTotalSoles" slot-scope="data"> 
                               S/.{{ data.item.importeTotalSoles}} 
                            </template>
                            <template slot="importePagadoSoles" slot-scope="data"> 
                               S/.{{ data.item.importePagadoSoles}} 
                            </template>
                            <template slot="importeTotalDolares" slot-scope="data"> 
                               $ {{ data.item.importeTotalDolares}} 
                            </template>
                            <template slot="importePagadoDolares" slot-scope="data"> 
                               $ {{ data.item.importePagadoDolares}} 
                            </template>
                        </b-table> -->
                        <b-modal
                            id="prevmodalGF"
                            size="lg"
                            title="Vista Previa"
                            cancel-title="Cerrar"
                            v-model="previewmodalGF"
                            >
                            <template v-if="cargandopdf2GF">
                                <div class="text-center">
                                <h3>
                                    <i class="fa fa-spin fa-spinner"></i>
                                </h3>Cargando vista previa
                                </div>
                            </template>
                            <template v-else>
                                <template v-if="pdfobjectGF !==''">
                                    <b-embed :src="'data:application/pdf;base64,'+ pdfobjectGF" allowfullscreen></b-embed>
                                </template>
                            </template>
                        </b-modal>
                        <b-modal   
                            id="modal-center" centered 
                            v-model="modalEstado"
                            >
                            <template slot="modal-title">
                                Documento: {{serieEstadoFactoring}} - {{numeroEstadoFactoring}}
                            </template>
                            <p>
                                {{estadoFactoring}}
                            </p>
                            <div slot="modal-footer">
                                <b-button variant="primary" @click="cerrarEstado()">OK</b-button>
                            </div>
                        </b-modal>
                        <b-modal id="modal1" title="Compartir Documento" v-model="previacorreo">
                            <template v-if="selected =='1' || selected == '2'">
                            <div style="background-color: #e7ffcd" class="p-2" role="group">
                                <label for="inputLive">Enviar por WhatsApp:
                                    <svg xmlns="http://www.w3.org/2000/svg" height="22" width="20" viewBox="0 0 448 512">
                                    <path fill="#0dc143" d="M92.1 254.6c0 24.9 7 49.2 20.2 70.1l3.1 5-13.3 48.6L152 365.2l4.8 2.9c20.2 12 43.4 18.4 67.1 18.4h.1c72.6 0 133.3-59.1 133.3-131.8c0-35.2-15.2-68.3-40.1-93.2c-25-25-58-38.7-93.2-38.7c-72.7 0-131.8 59.1-131.9 131.8zM274.8 330c-12.6 1.9-22.4 .9-47.5-9.9c-36.8-15.9-61.8-51.5-66.9-58.7c-.4-.6-.7-.9-.8-1.1c-2-2.6-16.2-21.5-16.2-41c0-18.4 9-27.9 13.2-32.3c.3-.3 .5-.5 .7-.8c3.6-4 7.9-5 10.6-5c2.6 0 5.3 0 7.6 .1c.3 0 .5 0 .8 0c2.3 0 5.2 0 8.1 6.8c1.2 2.9 3 7.3 4.9 11.8c3.3 8 6.7 16.3 7.3 17.6c1 2 1.7 4.3 .3 6.9c-3.4 6.8-6.9 10.4-9.3 13c-3.1 3.2-4.5 4.7-2.3 8.6c15.3 26.3 30.6 35.4 53.9 47.1c4 2 6.3 1.7 8.6-1c2.3-2.6 9.9-11.6 12.5-15.5c2.6-4 5.3-3.3 8.9-2s23.1 10.9 27.1 12.9c.8 .4 1.5 .7 2.1 1c2.8 1.4 4.7 2.3 5.5 3.6c.9 1.9 .9 9.9-2.4 19.1c-3.3 9.3-19.1 17.7-26.7 18.8zM448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM148.1 393.9L64 416l22.5-82.2c-13.9-24-21.2-51.3-21.2-79.3C65.4 167.1 136.5 96 223.9 96c42.4 0 82.2 16.5 112.2 46.5c29.9 30 47.9 69.8 47.9 112.2c0 87.4-72.7 158.5-160.1 158.5c-26.6 0-52.7-6.7-75.8-19.3z"/></svg>
                                </label>
                                <b-form-input type="number" style="border-color:black"  v-model="numeroWhatsApp" @keyup.enter="send_message(invoice)"></b-form-input>
                                <b-form-text
                                    style="font-size: small !important; color: #ea0909 !important"
                                    >Ingrese su número de celular (9 dígitos)
                                </b-form-text>
                                <b-row>
                                    <b-col cols="9"></b-col>
                                    <b-col>
                                        <b-btn
                                            :disabled="numeroWhatsApp.length < 9 || numeroWhatsApp.length > 9 "
                                            size="sm"
                                            variant="success"
                                            @click="send_message(invoice)"
                                            >Enviar
                                        </b-btn>
                                    </b-col>
                                </b-row>
                            </div>
                            </template>
                            <div style="background-color: #cce6ff" class="p-2" role="group">
                                <label for="inputLive">Enviar por Correo:</label>
                                <b-form-input style="border-color:black" v-model="recipients" type="email" @keyup.enter="sendMail(invoice)"></b-form-input>
                                <b-form-text
                                style="font-size: small !important; color: #ea0909 !important"
                                >Ingresa un correo ó varios separados por comas (,)</b-form-text>
                                <b-row>
                                    <b-col cols="9"></b-col>
                                    <b-col>
                                        <b-btn
                                        v-if="!sendcorreo"
                                        size="sm"
                                        variant="primary"
                                        @click="sendMail(invoice)"
                                        >Enviar
                                        </b-btn>
                                        <b-btn v-else size="sm" class="float-right" variant="secondary">
                                        <i class="fa fa-spin fa-spinner"></i> Enviando...
                                        </b-btn>
                                    </b-col>
                                </b-row>
                            </div>
                            <hr class="mt-3">
                                <h5>Correos en módulo Negocios:</h5>
                                <h5><li style="list-style:none" class="mr-1" variant="dark" v-for="(item,index) in reciveEmail" :key="index">
                                <b-badge pill variant="light">{{item}}
                                <i @click="borrarCorreo(index)" class=" fa fa-times-circle text-dark cursor"></i></b-badge> 
                                </li>
                                </h5>
                                <b-row>
                                    <b-col cols="9"></b-col>
                                    <b-col>
                                        <b-button v-if="recipients!=''" :disabled="mostraremail" size="sm" @click="enviarEmail(invoice)" variant="primary">Enviar a todos</b-button>
                                        <b-button v-else :disabled="mostraremail" size="sm" @click="enviarEmail(invoice)" variant="primary">Enviar</b-button>                              
                                    </b-col>
                                </b-row>
                                <div slot="modal-footer"></div>
                        </b-modal>            
                        <b-modal id="motivorechazo8" title="Motivo del Rechazo" v-model="motivoRechazo">
                            <div role="group">
                                <div v-if="spinoff">
                                    <div class="row">
                                        <div class="col-md-12 text-center">
                                            <h3>Cargando <i class="fa fa-spin fa-spinner"/></h3>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="row">
                                        <div class="col-md-12 text-center">
                                            <h6>{{ descripcionRechazo }}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div slot="modal-footer" class="w-100">
                                <b-btn v-if="!sendcorreo" size="sm" class="float-right" variant="primary" @click="motivoRechazo=!motivoRechazo">
                                    Ok
                                </b-btn>
                            </div>
                        </b-modal>
                        <b-modal id="prevmodal" size="lg" title="Vista Previa" cancel-title="Cerrar">
                            <template v-if="cargandopdf2"><div class="text-center"><h3><i class="fa fa-spin fa-spinner"/></h3> Cargando vista previa</div></template>
                            <template v-else>
                                <template v-if="pdfobject !==''">
                                    <b-embed :src="'data:application/pdf;base64,'+ pdfobject" allowfullscreen/>
                                </template>
                            </template>                
                        </b-modal>
                        <template v-if="rutaanticipos == 3">
                            <div class="row">
                                <div class="col-md-9">
                                    <p>Mostrando del {{desdeGF}} al {{hastaGF}} de un total de {{totalGF}} registros</p>
                                </div>
                                <div class="col-md-3">
                                    <b-pagination size="sm" :total-rows="totalGF" v-model="currentPageGF" :per-page="limiteGF" @input="globalFactoring"/>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="row">
                                <div class="col-md-9">
                                    <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
                                </div>
                                <div class="col-md-3">
                                    <b-pagination size="sm" :total-rows="total" v-model="currentPage" :per-page="limite" @input="selectorLista"/>
                                </div>
                            </div>
                        </template>
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <vue-snotify/>
        <b-modal id="modalpreproccess" v-model="modal">
            <template slot="modal-title">
                <i class="fa fa-exclamation-triangle text-danger"/> Dar de baja
            </template>
            <p class="my-4 h4"><b>{{this.$store.getters.userData.username}}</b>, realmente desea dar de baja al siguiente documento?</p>
            <b-list-group>
                <template>
                    <template>
                        <b-list-group-item>{{documentoItemBaja.serie + '-' + documentoItemBaja.numero + ' | ' + documentoItemBaja.idReceptor + '-' + documentoItemBaja.razonSocial}}</b-list-group-item>
                    </template>
                </template>
            </b-list-group>
            <br>
            <b-alert v-if="!loading2" variant="danger" show>El siguiente procedimiento no se puede deshacer.</b-alert>
            <b-alert v-else variant="danger" show>Estamos dando de baja los documentos indicados.</b-alert>
            <template slot="modal-footer">
                <template v-if="!loading2">
                <b-button variant="secondary" @click="modal=false">No</b-button>
                <b-button variant="danger" @click="sendBaja"><i class="fa fa-cog"/> Procesar</b-button>
                </template>
                <b-button v-else disabled variant="danger"><i class="fa fa-spin fa-cog"/> Procesando</b-button>
            </template>  
        </b-modal>
    </div>
</template>

<script>
import axios from 'axios'
//import DateRangePicker from 'vue2-daterange-picker'
import download from 'downloadjs'
import Terceros from '../../views/gestion/Terceros.vue'
/*
import ReporteFacturas from '@/components/factura/ReporteGeneralFactura'
import ReporteBoletas from '@/components/factura/ReporteGeneralFactura'
import ReporteNotasCredito from '@/components/factura/ReporteGeneralFactura'
import ReporteNotasDebito from '@/components/factura/ReporteGeneralFactura'
import ReporteGuias from '@/components/factura/ReporteGeneralFactura'
*/
export default {
        name: 'Documentos',
        props: ['tipoRecepcion'],
        components: {
    
                Terceros        /*
            ReporteFacturas,
            ReporteBoletas,
            ReporteNotasCredito,
            ReporteNotasDebito,
            ReporteGuias,
            DateRangePicker
            */
        },
        data:() => {
            return {
                bolBajaSerie:'',
                bolBajaNume:'',
                rutaexcelrango: 'facturas/excel/rangofechas',
                titleexcelrango: 'Reporte de facturas',
                rutabaja: 'comunicacionbaja/emitir',
                selectorDocumento: 1,
                selected: 1,
                options: [
                    { value: 1, text: '(F) Facturas' },
                    { value: 2, text: '(B) Boletas' },
                    { value: 3, text: '(NC) Notas de Crédito' },
                    { value: 4, text: '(ND) Notas de Débito' },
                    { value: 5, text: '(GR) Guias de Remision' },
                    { value: 6, text: '(NV) Nota Venta'},
                    { value: 7, text: 'Reporte Consolidado'},
                    { value: 8, text: 'Reporte Proforma'},
                    { value: 9, text: 'Reporte Orden de Compra'},
                    { value: 10, text: '(GT) Guias Transportista'}
                ],
                rutaanticipos: 1,
                motivoRechazo: false,
                spinoff: false,
                descripcionRechazo: '',
                documentoItemBaja: {
                    serie: '',
                    numero: '',
                    idReceptor: '',
                    razonSocial: ''
                },
                docBaja: {
                    descripcion: 'DE BAJA',
                    serie: '',
                    numero: '',
                    tipoComprobante: '01'
                },
                itembaja: [],
                date: '',
                loading2: false,
                modal: false,
                striped: true,
                small: true,
                outlined: true,
                filter: null,
                sortBy: null,
                sortDesc: false,
                sortDirection: 'desc',
                currentPage: 1,
                currentPageGF: 1,
                totalRows: null,
                pactual: 1,
                limite: 10,
                limiteGF: 10,
                orden: 'desc',
                ordenGF: 'desc',
                responseExportExcel: false,
                listfilters: [
                    {value: 1, text:'RUC'},
                    {value: 2, text:'RECEPTOR'},
                    {value: 3, text:'SERIE'},
                    {value: 4, text:'NUMERO'},
                    //{value: 5, text:'FECHA'},
                    {value: 6, text:'MONTO'},
                    {value: 7, text:'PROCESANDO'},
                    {value: 8, text:'RECHAZADO'},
                    {value: 9, text:'BAJA'},
                    {value: 10, text:'ANTICIPOS'},
                    {value: 11, text:'FACTURAS FACTORING'},
                ],
                listfilters2: [
                    {value: 1, text:'RUC'},
                    {value: 2, text:'EMISOR'},
                    {value: 3, text:'SERIE'},
                    {value: 4, text:'NUMERO'},
                    {value: 6, text:'MONTO'},
                    {value: 7, text:'PROCESANDO'},
                    {value: 8, text:'RECHAZADO'},
                    {value: 9, text:'BAJA'},
                    {value: 10, text:'ANTICIPOS'},
                ],
                filters : [],  
                invoices_final_fields: [],   
                invoices_fields: [
                    {key: 'creditoFac', label: ''},
                    {key: 'serie', label: 'Serie', sorteable: true},
                    {key: 'numero', label: 'Numero', sorteable: true},
                    {key: 'emision', label: 'Emisión', sorteable: true},
                    {key: 'usuario', label: 'Receptor', sorteable: true},
                    {key: 'emisor', label: 'Usuario', sortable: true},
                    {key: 'moneda', label: 'Importe Total', sorteable: true},
                    {key: 'estado', label: 'Estado', sorteable: true},
                    {key: 'acciones', label: 'Acciones'}
                ],
                invoices_recibidos_fields: [
                    {key: 'credito', label: ''},
                    {key: 'serie', label: 'Serie', sorteable: true},
                    {key: 'numero', label: 'Numero', sorteable: true},
                    {key: 'emision', label: 'Emisión', sorteable: true},
                    {key: 'usuario', label: 'Emisor', sorteable: true},
                    {key: 'moneda', label: 'Importe Total', sorteable: true},
                    {key: 'estado', label: 'Estado', sorteable: true},
                    {key: 'acciones', label: 'Acciones'}
                ],
                anticipos_fields: [
                    {key: 'serie', label: 'Serie', sorteable: true},
                    {key: 'numero', label: 'Numero', sorteable: true},
                    {key: 'idReceptor', label: 'Receptor', sorteable: true},
                    {key: 'montoRegularizar', label: 'Monto por regularizar', sorteable: true},
                    {key: 'acciones', label: 'Acciones'}
                ],
                // facturas_credito_fields: [
                //     {key: 'creditoFac', label: ''},
                //     {key: 'documento', label: 'Documento', sorteable: true},
                //     {key: 'emision', label: 'Emisión', sorteable: true},
                //     {key: 'vencimiento', label: 'Vencimiento', sorteable: true},
                //     {key: 'receptor', label: 'Receptor', sorteable: true},
                //     {key: 'importeTotalSoles', label: 'Total Soles', sorteable: true},
                //     {key: 'importePagadoSoles', label: 'Pago Soles', sorteable: true},
                //     {key: 'importeTotalDolares', label: 'Total Dólares', sorteable: true},
                //     {key: 'importePagadoDolares', label: 'Pago Dólares', sorteable: true},
                //     ],
                listaitems_fields: [
                    {key: 'index'},
                    {key: 'codigoItem', label: 'Codigo', sorteable: true},
                    {key: 'UniMedItem', label: 'Unidad', sorteable: true},
                    {key: 'descripcion', label: 'Descripción', sorteable: true},
                    {key: 'cantidad', label: 'Cantidad', sorteable: true},
                    {key: 'precioVentaUnitario', label: 'Precio Unit', sorteable: true},
                    {key: 'descuento', label: 'Descuento', sorteable: true},
                    {key: 'valorVenta', label: 'Valor Venta', sorteable: true},
                ],
                listaitems_fieldsProforma: [
                    {key: 'index'},
                    {key: 'codigoItem', label: 'Codigo', sorteable: true},
                    {key: 'UniMedItem', label: 'Unidad', sorteable: true},
                    {key: 'descripcion', label: 'Descripción', sorteable: true},
                    {key: 'cantidad', label: 'Cantidad', sorteable: true},
                    {key: 'precioVentaUnitario', label: 'Precio Unit', sorteable: true},
                    {key: 'descuento', label: 'Descuento', sorteable: true},
                    {key: 'valorVenta', label: 'valor Venta', sorteable: true},
                ],
                tablefilter: '',
                total: 0,
                totalGF: 0,
                correos: '',
                pdfobject: '',
                pdfobjectGF: '',
                recipients: '',
                desde: '',
                hasta: '',
                desdeGF: '',
                hastaGF: '',
                cargando: false,
                previacorreo: false,
                sendcorreo: false,
                cargandopdf: false,
                cargandopdf2: false,
                cargandopdf2GF: false,             
                principal: [],
                // facCredito:[],
                principal2: [],
                anticipos: [],
                globalFac:[],
                globalFac_fields: [
                    {key: 'serieNumero', label: 'Documento', sorteable: true},
                    {key: 'emisor', label: 'RUC - Emisor', sorteable: true},
                    {key: 'fechaCreacion', label: 'Fecha Creación', sorteable: true},
                    {key: 'estado', label: 'Estado', sorteable: true},
                    {key: 'acciones', label: 'Acciones'}
                ],
                globalFacJsonBody_fields: [
                    {key: 'GFIntDocumento', label: 'Documento', sorteable: true},
                    {key: 'GFIntImporte', label: 'Importe Factura', sorteable: true},
                    {key: 'GFIntRUCPagador', label: 'RUC - Pagador', sorteable: true},
                    {key: 'GFIntRazonSocialPagador', label: 'RazonSocial - Pagador', sorteable: true},
                    {key: 'GFContacto', label: 'Contacto', sorteable: true},
                    {key: 'GFEmail', label: 'Email', sorteable: true},
                    {key: 'GFTelefono', label: 'Celular', sorteable: true},
                ],
                globalFactoringLista:false,
                q: [],
                f1: '',
                f2: '',
                fe1: '',
                fe2: '',
                loadingexcelreport: false,
                loadingexcelConsolidado:false,
                idDocumento: null,
                rutasinit: [
                    { id:1, initcadena: 'facturas/' },
                    { id:1, initcadena: 'boletas/' },
                    { id:1, initcadena: 'notacredito/' },
                    { id:1, initcadena: 'notadebito/' },
                    { id:1, initcadena: 'guiaremitente/' },
                    { id:1, initcadena: 'notaventa/' },
                    { id:1, initcadena: 'proformas/' },
                    { id:1, initcadena: 'ordencompra/' },
                    { id:1, initcadena: 'guiaremitente/guiatransportista/' },
                    // { id:1, initcadena: 'documentoscredito/' },
                    
                ],
                rutasrecibidosinit: [
                    { id:1, initcadena: 'facturas/recibidas/' },
                    { id:1, initcadena: 'boletas/recibidas/' },
                    { id:1, initcadena: 'notacredito/recibidas/' },
                    { id:1, initcadena: 'notadebito/recibidas/' },
                    { id:1, initcadena: 'guiaremitente/recibidas/' },
                    { id:1, initcadena: 'notaventa/recibidas/' },
                    { id:1, initcadena: 'proformas/recibidas/' },
                    { id:1, initcadena: 'ordencompra/recibidas/' }
                ],
                rutasrecibidos: {
                    reporte: 'reporte',
                    reporte2:'reporte/porpagar',
                    xml: 'xml',
                    cdr: 'constancia',
                    pdf: 'pdf',
                    mail: 'mail'
                }, 
                rutalista: 'facturas/reporte',
                rutamail: 'facturas/mail',
                rutaxml: 'facturas/xml',
                rutapdf: 'facturas/pdf',
                rutaconstancia: 'facturas/constancia',
                rutarecibidaslista: 'facturas/recibidas/reporte',
                rutarecibidasxml: 'facturas/recibidas/xml',
                rutarecibidasconstancia: 'facturas/recibidas/constancia',
                rutarecibidasmail: 'facturas/mail/recibido',
                rutarecibidaspdf: 'facturas/recibidas/pdf',
                rutaitem: 'facturas/',
                listaRecibidos: [],
                emitidorecibido: 0,
                filtros: [],
                reciveEmail:[],
                mostraremail: true,
                customers:[],
                rango1:'',
                rango2:'',
                previewmodalGF:false,
                modalEstado:false,
                estadoFactoring:'',
                serieEstadoFactoring:'',
                numeroEstadoFactoring:'',
                numeroWhatsApp:'',
            }
        },
        mounted () {          
            this.selectorLista();
            this.listTerceros();
        },
        watch: {
            filters: function () {
                if(this.filters.length === 0){
                    this.selectorLista()
                }
            },
            selected: function () {
                switch (this.selected) {
                    case 1:
                        this.rutaexcelrango = 'facturas/excel/rangofechas';
                        this.titleexcelrango = 'Reporte de facturas';
                        this.rutabaja = 'comunicacionbaja/emitir';
                        this.rutalista = this.rutasinit[0].initcadena + this.rutasrecibidos.reporte;
                        this.rutaxml = this.rutasinit[0].initcadena + this.rutasrecibidos.xml;
                        this.rutaconstancia = this.rutasinit[0].initcadena + this.rutasrecibidos.cdr;
                        this.rutamail = this.rutasinit[0].initcadena + this.rutasrecibidos.mail;
                        this.rutapdf = this.rutasinit[0].initcadena + this.rutasrecibidos.pdf;
                        this.rutarecibidaslista = this.rutasrecibidosinit[0].initcadena + this.rutasrecibidos.reporte;
                        this.rutarecibidasxml = this.rutasrecibidosinit[0].initcadena + this.rutasrecibidos.xml;
                        this.rutarecibidasconstancia = this.rutasrecibidosinit[0].initcadena + this.rutasrecibidos.constancia;
                        this.rutarecibidasmail = this.rutasrecibidosinit[0].initcadena + this.rutasrecibidos.mail;
                        this.rutarecibidaspdf = this.rutasrecibidosinit[0].initcadena + this.rutasrecibidos.pdf;
                        this.rutaitem = this.rutasinit[0].initcadena;
                        break;
                    case 2: 
                        this.rutaexcelrango = 'boletas/excel/rangofechas';
                        this.titleexcelrango = 'Reporte de boletas';
                        this.rutabaja = 'comunicacionbaja/emitir/boleta';
                        this.rutalista = this.rutasinit[1].initcadena + this.rutasrecibidos.reporte;
                        this.rutaxml = this.rutasinit[1].initcadena + this.rutasrecibidos.xml;
                        this.rutaconstancia = this.rutasinit[1].initcadena + this.rutasrecibidos.cdr;
                        this.rutamail = this.rutasinit[1].initcadena + this.rutasrecibidos.mail;
                        this.rutapdf = this.rutasinit[1].initcadena + this.rutasrecibidos.pdf;
                        this.rutarecibidaslista = this.rutasrecibidosinit[1].initcadena + this.rutasrecibidos.reporte;
                        this.rutarecibidasxml = this.rutasrecibidosinit[1].initcadena + this.rutasrecibidos.xml;
                        this.rutarecibidasconstancia = this.rutasrecibidosinit[1].initcadena + this.rutasrecibidos.constancia;
                        this.rutarecibidasmail = this.rutasrecibidosinit[1].initcadena + this.rutasrecibidos.mail;
                        this.rutarecibidaspdf = this.rutasrecibidosinit[1].initcadena + this.rutasrecibidos.pdf;
                        this.rutaitem = this.rutasinit[1].initcadena;
                        break;
                    case 3: 
                        this.rutaexcelrango = 'notacredito/excel/rangofechas';
                        this.titleexcelrango = 'Reporte de notas de credito';
                        this.rutalista = this.rutasinit[2].initcadena + this.rutasrecibidos.reporte;
                        this.rutaxml = this.rutasinit[2].initcadena + this.rutasrecibidos.xml;
                        this.rutaconstancia = this.rutasinit[2].initcadena + this.rutasrecibidos.cdr;
                        this.rutamail = this.rutasinit[2].initcadena + this.rutasrecibidos.mail;
                        this.rutapdf = this.rutasinit[2].initcadena + this.rutasrecibidos.pdf;
                        this.rutarecibidaslista = this.rutasrecibidosinit[2].initcadena + this.rutasrecibidos.reporte;
                        this.rutarecibidasxml = this.rutasrecibidosinit[2].initcadena + this.rutasrecibidos.xml;
                        this.rutarecibidasconstancia = this.rutasrecibidosinit[2].initcadena + this.rutasrecibidos.constancia;
                        this.rutarecibidasmail = this.rutasrecibidosinit[2].initcadena + this.rutasrecibidos.mail;
                        this.rutarecibidaspdf = this.rutasrecibidosinit[2].initcadena + this.rutasrecibidos.pdf;
                        this.rutaitem = this.rutasinit[2].initcadena;
                        this.rutabaja = '';
                        break;
                    case 4: 
                        this.rutaexcelrango = 'notadebito/excel/rangofechas';
                        this.titleexcelrango = 'Reporte de notas de debito';
                        this.rutalista = this.rutasinit[3].initcadena + this.rutasrecibidos.reporte;
                        this.rutaxml = this.rutasinit[3].initcadena + this.rutasrecibidos.xml;
                        this.rutaconstancia = this.rutasinit[3].initcadena + this.rutasrecibidos.cdr;
                        this.rutamail = this.rutasinit[3].initcadena + this.rutasrecibidos.mail;
                        this.rutapdf = this.rutasinit[3].initcadena + this.rutasrecibidos.pdf;
                        this.rutarecibidaslista = this.rutasrecibidosinit[3].initcadena + this.rutasrecibidos.reporte;
                        this.rutarecibidasxml = this.rutasrecibidosinit[3].initcadena + this.rutasrecibidos.xml;
                        this.rutarecibidasconstancia = this.rutasrecibidosinit[3].initcadena + this.rutasrecibidos.constancia;
                        this.rutarecibidasmail = this.rutasrecibidosinit[3].initcadena + this.rutasrecibidos.mail;
                        this.rutarecibidaspdf = this.rutasrecibidosinit[3].initcadena + this.rutasrecibidos.pdf;
                        this.rutaitem = this.rutasinit[3].initcadena;
                        this.rutabaja = '';
                        break;
                    case 5: 
                        this.rutaexcelrango = 'guiaremitente/excel/rangofechas';
                        this.titleexcelrango = 'Reporte de guias de remision';
                        this.rutalista = this.rutasinit[4].initcadena + this.rutasrecibidos.reporte;
                        this.rutaxml = this.rutasinit[4].initcadena + this.rutasrecibidos.xml;
                        this.rutaconstancia = this.rutasinit[4].initcadena + 'cdr';
                        this.rutamail = this.rutasinit[4].initcadena + this.rutasrecibidos.mail;
                        this.rutapdf = this.rutasinit[4].initcadena + this.rutasrecibidos.pdf;
                        this.rutarecibidaslista = this.rutasrecibidosinit[4].initcadena + this.rutasrecibidos.reporte;
                        this.rutarecibidasxml = this.rutasrecibidosinit[4].initcadena + this.rutasrecibidos.xml;
                        this.rutarecibidasconstancia = this.rutasrecibidosinit[4].initcadena + this.rutasrecibidos.constancia;
                        this.rutarecibidasmail = this.rutasrecibidosinit[4].initcadena + this.rutasrecibidos.mail;
                        this.rutarecibidaspdf = this.rutasrecibidosinit[4].initcadena + this.rutasrecibidos.pdf;
                        this.rutaitem = this.rutasinit[4].initcadena;
                        this.rutabaja = '';
                        break;
                    case 6:
                        this.rutaexcelrango = 'notaventa/excel/rangofechas';
                        this.titleexcelrango = 'Reporte de Nota Ventas';
                        this.rutalista = this.rutasinit[5].initcadena + this.rutasrecibidos.reporte;
                        this.rutaxml = this.rutasinit[5].initcadena + this.rutasrecibidos.xml;
                        this.rutaconstancia = this.rutasinit[5].initcadena + this.rutasrecibidos.cdr;
                        this.rutamail = this.rutasinit[5].initcadena + this.rutasrecibidos.mail;
                        this.rutapdf = this.rutasinit[5].initcadena + this.rutasrecibidos.pdf;
                        this.rutarecibidaslista = this.rutasrecibidosinit[5].initcadena + this.rutasrecibidos.reporte;
                        this.rutarecibidasxml = this.rutasrecibidosinit[5].initcadena + this.rutasrecibidos.xml;
                        this.rutarecibidasconstancia = this.rutasrecibidosinit[5].initcadena + this.rutasrecibidos.constancia;
                        this.rutarecibidasmail = this.rutasrecibidosinit[5].initcadena + this.rutasrecibidos.mail;
                        this.rutarecibidaspdf = this.rutasrecibidosinit[5].initcadena + this.rutasrecibidos.pdf;
                        this.rutaitem = this.rutasinit[5].initcadena;
                        this.rutabaja = '';
                        break;
                    case 7:
                        this.rutaexcelrango = 'reportes/global';
                        this.titleexcelrango = 'Reporte Consolidado';  
                        break;
                    case 8:
                        this.rutaexcelrango = 'proformas/excel/rangofechas';
                        this.titleexcelrango = 'Reporte de Proformas';
                        this.rutalista = this.rutasinit[6].initcadena + this.rutasrecibidos.reporte;
                        this.rutaxml = this.rutasinit[6].initcadena + this.rutasrecibidos.xml;
                        this.rutaconstancia = this.rutasinit[6].initcadena + this.rutasrecibidos.cdr;
                        this.rutamail = this.rutasinit[6].initcadena + this.rutasrecibidos.mail;
                        this.rutapdf = this.rutasinit[6].initcadena + this.rutasrecibidos.pdf;
                        this.rutarecibidaslista = this.rutasrecibidosinit[6].initcadena + this.rutasrecibidos.reporte;
                        this.rutarecibidasxml = this.rutasrecibidosinit[6].initcadena + this.rutasrecibidos.xml;
                        this.rutarecibidasconstancia = this.rutasrecibidosinit[6].initcadena + this.rutasrecibidos.constancia;
                        this.rutarecibidasmail = this.rutasrecibidosinit[6].initcadena + this.rutasrecibidos.mail;
                        this.rutarecibidaspdf = this.rutasrecibidosinit[6].initcadena + this.rutasrecibidos.pdf;
                        this.rutaitem = this.rutasinit[6].initcadena;
                        this.rutabaja = '';
                        break;
                    case 9:
                        this.rutaexcelrango = 'ordencompra/excel/rangofechas';
                        this.titleexcelrango = 'Reporte de Orden Compra';
                        this.rutalista = this.rutasinit[7].initcadena + this.rutasrecibidos.reporte;
                        this.rutaxml = this.rutasinit[7].initcadena + this.rutasrecibidos.xml;
                        this.rutaconstancia = this.rutasinit[7].initcadena + this.rutasrecibidos.cdr;
                        this.rutamail = this.rutasinit[7].initcadena + this.rutasrecibidos.mail;
                        this.rutapdf = this.rutasinit[7].initcadena + this.rutasrecibidos.pdf;
                        this.rutarecibidaslista = this.rutasrecibidosinit[7].initcadena + this.rutasrecibidos.reporte;
                        this.rutarecibidasxml = this.rutasrecibidosinit[7].initcadena + this.rutasrecibidos.xml;
                        this.rutarecibidasconstancia = this.rutasrecibidosinit[7].initcadena + this.rutasrecibidos.constancia;
                        this.rutarecibidasmail = this.rutasrecibidosinit[7].initcadena + this.rutasrecibidos.mail;
                        this.rutarecibidaspdf = this.rutasrecibidosinit[7].initcadena + this.rutasrecibidos.pdf;
                        this.rutaitem = this.rutasinit[7].initcadena;
                        this.rutabaja = '';
                        break;
                    case 10:
                        this.rutaexcelrango = 'guiaremitente/guiatransportista/excel/rangofechas';
                        this.titleexcelrango = 'Reporte Guia Transportista';
                        // this.rutalista = this.rutasinit[8].initcadena + this.rutasrecibidos.reporte2; //facturas a credito por pagar
                        this.rutalista = this.rutasinit[8].initcadena + this.rutasrecibidos.reporte;
                        this.rutapdf = this.rutasinit[8].initcadena + this.rutasrecibidos.pdf;
                        this.rutaxml = this.rutasinit[8].initcadena + this.rutasrecibidos.xml;
                        this.rutaconstancia = this.rutasinit[8].initcadena + 'cdr';
                        break;  
                }
                this.selectorLista()
            }
        },
        methods: {
            mostrarDetalles: function (row, index) {
                
                if(row.detailsShowing){
                    row.toggleDetails();
                    this.principal[index].mostrardetalles = false
                }else{
                   if(this.selected != 6 && this.selected != 8 && this.selected != 9){
                        this.principal[index].mostrardetalles = true;
                        this.principal[index].loading = true;
                        if( this.principal[index].lista.length === 0){
                            setTimeout(() => 
                                this.detallesDocumento(row, index)
                            , 10);  
                        }else{
                            this.principal[index].loading = false;
                            row.toggleDetails()
                        }
                   }else if(this.selected == 6){
                       this.principal[index].mostrardetalles = true;
                        this.principal[index].loading = true;
                        if( this.principal[index].notaVenta.items.length === 0){
                            setTimeout(() => 
                                this.detallesDocumento(row, index)
                            , 10);  
                        }else{
                            this.principal[index].loading = false;
                            row.toggleDetails()
                        }
                   }else if(this.selected == 8){             
                       this.principal[index].mostrardetalles = true;
                        this.principal[index].loading = true;
                        if( this.principal[index].proforma.items.length === 0){
                            setTimeout(() => 
                                this.detallesDocumento(row, index)
                            , 10);  
                        }else{
                            this.principal[index].loading = false;
                            row.toggleDetails()
                        }
                   }else if(this.selected == 9){             
                       this.principal[index].mostrardetalles = true;
                        this.principal[index].loading = true;
                        if( this.principal[index].ordenCompra.items.length === 0){
                            setTimeout(() => 
                                this.detallesDocumento(row, index)
                            , 10);  
                        }else{
                            this.principal[index].loading = false;
                            row.toggleDetails()
                        }
                   }
                }
            },
            detallesDocumento: function (row, index) {
                let objeto = {};
                objeto.token = this.$store.getters.userToken;
                switch(this.selected){
                    case 1: 
                        objeto.idfac = row.item.idFactura;
                        break;
                    case 2: 
                        objeto.idbol = row.item.idBoleta;
                        break;
                    case 3:
                        objeto.idcredit = row.item.idNotaCredito;
                        break;
                    case 4: 
                        objeto.iddebit = row.item.idNotaDebito;
                        break;
                    case 5: 
                        objeto.idguia = row.item.idGuiaRemitente;
                        break;
                }
                axios
                .post(process.env.VUE_APP_API_URL + this.rutaitem+'items',objeto)
                .then(response => (
                    this.parseDetallesDocumento(response.data.response, row, index)
                ))
                .catch(error => {
                    this.principal[index].mostrardetalles = false;
                })
            },
            parseDetallesDocumento: function (value, row, index) {
                this.principal[index].lista = [];
                for (let i=0; i<value.length; i++){
                    value[i].moneda = row.item.tipoMoneda;
                    this.principal[index].lista.push(value[i])
                }
                this.principal[index].loading = false;
                // this.principal[index].mostrardetalles = false
                if(value.length > 0){
                    row.toggleDetails()
                }
            },
            selectorLista: function () {
                if(this.tipoRecepcion === 0){
                    this.emitidorecibido = this.tipoRecepcion ;
                    this.filtros = this.listfilters;
                    this.invoices_final_fields = this.invoices_fields;
                    this.listInvoice(1)
                }else if(this.tipoRecepcion === 1){
                    this.emitidorecibido = this.tipoRecepcion;
                    this.filtros = this.listfilters2;
                    this.invoices_final_fields = this.invoices_recibidos_fields;
                    this.listInvoice(2)
                }
            },
            advertConvertCredit: function (data) {
                this.$swal({
                title: 'Convertir a Credito',
                text: 'Seguro que desea convertir a credito el documento '+ data.serie+'-'+data.numero,
                icon: 'warning',
                buttons: true,
                dangerMode: true
                }).then((willDelete) => {
                if(willDelete){
                    this.cargando = true;
                    this.convertCredit(data)
                }
                })
            },
            convertCredit: function (data) {
                let idDocumento = ''
                let tipoDocumento = ''
                if(data.serie.charAt(0) !='F'){
                   idDocumento = data.idBoleta 
                   tipoDocumento = '03'
                }else if(data.serie.charAt(0) !='B'){
                    idDocumento = data.idFactura
                    tipoDocumento = '01'
                }
                axios
                .post(process.env.VUE_APP_API_URL + 'documentoscredito/convertirdoc',{
                    token: this.$store.getters.userToken,
                    tipodocumento: tipoDocumento,
                    iddocumento: idDocumento
                })
                .then(response => {
                    this.$snotify.success(response.data.msg,'Exito');
                    this.listInvoice(1);
                })
                .catch(error => (
                    this.$snotify.error(error.response.data.msg,'Error')
                ))
            },
            identificadorDocumento: function (data) {
                if(this.selected === 1){
                    this.idDocumento = data.idFactura;
                    this.selectorDocumento = 1
                }else if(this.selected === 2){
                   this.idDocumento = data.idBoleta;
                    this.selectorDocumento = 2
                }else if(this.selected === 3) {
                    this.idDocumento = data.idNotaCredito;
                    if(data.tipoComprobanteAfectado==='01'){
                        this.rutabaja = 'comunicacionbaja/emitir';
                        this.selectorDocumento = 1
                    }else if(data.tipoComprobanteAfectado==='03'){
                        this.rutabaja = 'comunicacionbaja/emitir/ncboleta';
                        this.selectorDocumento = 2
                    }
                }else if(this.selected === 4) {
                    this.idDocumento = data.idNotaDebito;
                    if(data.tipoComprobanteAfectado==='01'){
                        this.rutabaja = 'comunicacionbaja/emitir';
                        this.selectorDocumento = 1
                    }else if(data.tipoComprobanteAfectado==='03'){
                        this.rutabaja = '';
                        this.selectorDocumento = 2
                    }
                }else if(this.selected === 5){
                    this.idDocumento = data.idGuiaRemitente
                }else if(this.selected === 6){
                    this.idDocumento = data.idNotaVenta
                }else if(this.selected === 8){
                    this.idDocumento = data.idProforma
                }else if(this.selected === 9){
                    this.idDocumento = data.idOrdenCompra
                }else if(this.selected === 10){
                    this.idDocumento = data.idGuiaTransportista
                }
                return this.idDocumento
            },
            validateFilters: function () {
                if(this.filters.length === 0 && !(this.f1!=='' && this.f2!=='')){
                    return true
                }else if(this.filters.length > 0 || this.tablefilter !==''){
                    return false
                }
            },
            listAnticipos: function () {
                this.cargando = true;
                axios
                .post(process.env.VUE_APP_API_URL + 'anticipos/porregularizar', {
                    token: this.$store.getters.userToken
                })
                .then(response => {
                    this.anticipos = response.data.data;
                    this.cargando = false
                })
                .catch(error => {
                        this.cargando = false;
                    this.$snotify.error(error.response.data.response, 'Error');
                })
            },
            globalFactoring: function () {
                this.cargando = true;
                axios
                .post(process.env.VUE_APP_API_URL + 'globalfactoring/listar ', {
                    token: this.$store.getters.userToken,
                    page: this.currentPageGF,
                    l: this.limiteGF,
                    order: this.ordenGF,
                })
                .then(response => (
                    this.cargando = false,
                    this.globalFac = response.data.data,
                    this.parseandoGlobal(this.globalFac),
                    this.totalGF = response.data.total,
                    this.desdeGF = response.data.from,
                    this.hastaGF = response.data.to
                ))
                .catch(error => (
                    this.cargando = false,
                    this.$snotify.error(error.response, 'Error')
                ))
            },
            parseandoGlobal(array){
                let idGlobalFac;
                let reciveGlobalFac;
                let jsonBodyParseado;
                reciveGlobalFac = array,
                    array.forEach(element => {
                        idGlobalFac = element.idGlobalWin
                        jsonBodyParseado = JSON.parse(element.jsonBody)
                        reciveGlobalFac.forEach(element => {
                            if(element.idGlobalWin == idGlobalFac){
                                element.jsonBody = jsonBodyParseado
                            }
                        });
                    }),
                    this.globalFac = reciveGlobalFac
            },
            mostrarItems(row, index){
                if(row.detailsShowing){
                    row.toggleDetails()
                    this.globalFac[index].mostrardetalles = false
                }else{       
                    this.globalFac[index].mostrardetalles = true
                    this.globalFac[index].loading = true
                    row.toggleDetails()
                }
            },
            consultarEstado(item){
                this.serieEstadoFactoring = item.serie;
                this.numeroEstadoFactoring = item.numero;
                axios
                .post(process.env.VUE_APP_API_URL + "globalfactoring/estado",{
                    token: this.$store.getters.userToken,
                    tipoDocumento: item.tipoDocumento,
                    idDocumento:item.idDocumento
                    })
                .then(response =>(
                    this.estadoFactoring = response.data.msg,
                    this.modalEstado = true
                ))
                .catch(error=>(
                    console.log(error.data)
                ))
            },
            cerrarEstado(){
                this.modalEstado = false;
            },

            viewPdfGF: function(data) {
                (this.previewmodalGF = true),
                (this.pdfobjectGF = ""),
                (this.cargandopdf2GF = true);
                axios
                .post(process.env.VUE_APP_API_URL + "facturas/pdf",{
                    token: this.$store.getters.userToken,
                    id: data.idDocumento
                    })
                .then(response => ((
                        this.pdfobjectGF = response.data.base64), 
                        (this.cargandopdf2GF = false)
                    ))
                .catch(error => {});
            },
            addFilter: function(data) {
                let filter = {};
                filter.type = data.value;
                filter.name = data.text;
                if(data.value === 7){
                    filter.value = '0';
                    this.selectorLista()
                } else if(data.value === 8){
                    filter.value = '2';
                    this.selectorLista()
                } else if(data.value === 9) {
                    filter.value = '1';
                    this.selectorLista()
                } else if(data.value === 10) {
                    this.filters = [];
                    this.rutaanticipos = 2;
                    filter.value = '3';
                    this.listAnticipos()
                }else if(data.value === 11){
                    this.filters = [];
                    this.rutaanticipos = 3;
                    this.globalFactoring()
                }else {
                    filter.value = ''
                }
                this.filters.push(filter);
                this.q.push(filter)
            },
            removeFilter: function(data) {
                if(this.rutaanticipos){
                    this.rutaanticipos = 1
                }
                this.filters.splice(data, 1);
                this.q.splice(data, 1)
            },
            sendMail: function (data) {
                this.previacorreo = true;
                this.sendcorreo = true;
                let id;
                let rutaactual;
                id = this.identificadorDocumento(data);
                this.emitidorecibido === 0 ? rutaactual = this.rutamail: rutaactual = this.rutarecibidasmail;
                if(this.selected == 6){
                    rutaactual = 'notaventa/pdf/mail'
                }
                axios
                .post(process.env.VUE_APP_API_URL + rutaactual, {
                    token: this.$store.getters.userToken,
                    id: id,
                    mail: this.recipients 
                })
                .then(response => {
                    this.previacorreo = false;
                    this.sendcorreo = false;
                    this.$snotify.success(response.data.msg, 'Exito');
                    this.recipients = ''
                    })
                .catch(error => {
                    this.previacorreo = false;
                    this.sendcorreo = false;
                    this.$snotify.error(error.response.data.response, 'Error')
                })
            },
            downloadXml: function (data){
                let xml = '';
                let file = '';
                let name = data.serie + '-' + data.numero + '.zip';
                let tag = document.createElement('i');
                let id;
                let rutaactual;
                this.cargandopdf = true;
                tag.classList.add('fa','fa-spin', 'fa-spinner');
                this.$swal({
                title: 'Obteniendo XML',
                content: tag,
                icon: 'info',
                buttons: false,
                dangerMode: false
                });
                id = this.identificadorDocumento(data);
                let paquete = this.setPackage(id, data.idEmisor);
                this.emitidorecibido === 0 ? rutaactual = this.rutaxml: rutaactual = this.rutarecibidasxml;
                axios
                .post(process.env.VUE_APP_API_URL + rutaactual, paquete)
                .then(response => {
                    xml = response.data.response.xml;
                    file = 'data:application/zip;base64,'+ xml;
                    this.downloadxml(file, name, xml);
                    this.$swal.close()
                })
                .catch(error => {
                    this.$snotify.error('Error al descargar el archivo', 'Error');
                })
            },
            downloadxml: function (file, name, xml) {
                if(xml != null){
                    download(file, name,'application/zip')
                }else{
                    this.$snotify.error('El documento aun no tiene constancia porque esta en proceso!', 'Error')
                }  
            },
            viewPdf: function (data) {
                let rutaactual;
                this.pdfobject = '';
                this.cargandopdf2 = true;
                let id;
                id = this.identificadorDocumento(data);
                let paquete = this.setPackage(id, data.idEmisor);
                this.emitidorecibido === 0 ? rutaactual = this.rutapdf: rutaactual = this.rutarecibidaspdf;
                axios
                .post(process.env.VUE_APP_API_URL + rutaactual, paquete)
                .then(response => {
                if(this.selected == 6 || this.selected == 8 || this.selected == 9){
                    this.pdfobject = response.data.pdf;  
                } else{
                    this.pdfobject = response.data.base64; 
                }
                    this.cargandopdf2 = false
                })
                //.catch(error => { console.log(error)})
            },
            downloadPdf: function (data){
                let paquete;
                let tag = document.createElement('i');
                tag.classList.add('fa','fa-spin', 'fa-spinner');
                let name = data.serie + '-' + data.numero + '.pdf';
                let file = 'data:application/pdf;base64,'+ data.pdf;
                let rutaactual;
                this.cargandopdf = true;
                this.$swal({
                    title: 'Procesando Descarga',
                    content: tag,
                    icon: 'info',
                    buttons: false,
                    dangerMode: false
                });
                let id;
                id = this.identificadorDocumento(data);
                if(this.rutaanticipos == 3){
                     paquete = this.setPackage(data.idDocumento, data);
                }else{
                     paquete = this.setPackage(id, data.idEmisor);
                }
                this.emitidorecibido === 0 ? rutaactual = this.rutapdf: rutaactual = this.rutarecibidaspdf;
                axios
                .post(process.env.VUE_APP_API_URL + rutaactual, paquete)
                .then(response => {
                    file = 'data:application/zip;base64,'+ response.data.base64;
                    this.cargandopdf = false;
                    download(file, name,'application/pdf');
                    this.$swal.close()
                })
                .catch(function (error){
                    this.$snotify.error(error.response.data.response, 'Error')
                })            
            },
            setPackage: function (id, emisor) {
                let paquete = {
                    token: this.$store.getters.userToken,
                    id: id
                };
                if(this.emitidorecibido === 1){
                    paquete.emisor = emisor
                }
                return paquete
            },
            downloadCdr: function (data){
                let tag = document.createElement('i');
                tag.classList.add('fa','fa-spin', 'fa-spinner');
                let name = 'CDR-' + data.serie + '-' + data.numero + '.zip';
                let file = 'data:application/pdf;base64,'+ data.pdf;
                let rutaactual;
                this.cargandocdr = true;
                this.$swal({
                    title: 'Procesando Descarga',
                    content: tag,
                    icon: 'info',
                    buttons: false,
                    dangerMode: false
                });
                let id;
                id = this.identificadorDocumento(data);
                let paquete = this.setPackage(id, data.idEmisor);
                this.emitidorecibido === 0 ? rutaactual = this.rutaconstancia: rutaactual = this.rutarecibidasconstancia;
                axios
                .post(process.env.VUE_APP_API_URL + rutaactual, paquete)
                .then(response => {
                    this.$swal.close();
                    file = 'data:application/zip;base64,'+ response.data.msg.xml;
                    this.downloadcdr(file, name, response.data);
                    this.cargandocdr = false
                })
                .catch(error =>{
                    this.$swal.close();
                    this.$snotify.error(error.response.data.msg, 'Error')
                })
            },
            downloadcdr: function (file, name, value) {
                if(value.success === 0){
                    this.$snotify.error('El documento aun no tiene constancia porque esta en proceso!', 'Error')
                }else{
                    download(file, name,'application/zip')
                }  
            },
            listInvoice: function (tipo) {
                this.responseExportExcel = false;
                this.cargando = true;
                let date1;
                let date2;
                let rutaactual;
                if(this.f1 === ''){
                    // date1 = this.$moment().subtract(2,'years').startOf('day').format('YYYY-MM-DD HH:mm:ss')
                    date1 = ""
                }
                else
                {
                    date1 = this.$moment(this.f1).startOf('day').format('YYYY-MM-DD HH:mm:ss')
                }
                if(this.f2 === ''){
                    // date2 = this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
                    date2 = ""
                }
                else
                {
                    date2 = this.$moment(this.f2).endOf('day').format('YYYY-MM-DD HH:mm:ss')
                }
                tipo === 1 ? rutaactual = this.rutalista: rutaactual = this.rutarecibidaslista;
                axios
                .post(process.env.VUE_APP_API_URL + rutaactual, {
                    token: this.$store.getters.userToken,
                    page: this.currentPage,
                    l: this.limite,
                    order: this.orden,
                    q: this.q,
                    f1: date1,
                    f2: date2,
                    rango1: this.rango1,
                    rango2: this.rango2
                })
                .then(response => {
                    this.principal = response.data.report.data;
                    // this.facCredito = response.data.report.data;
                    this.totalRows = this.principal.length;
                    this.total = response.data.report.total;
                    this.desde = response.data.report.from;
                    this.hasta = response.data.report.to;
                    this.cargando = false;
                    this.principal.forEach(function(element){
                        element.loading = false
                    })
                    // this.interceptData(response.data, tipo)
                })
                .catch(error => (
                    this.$snotify.error(error.response.data.response, 'Error')
                ))
            },
            /*
            interceptData: function (data, tipo) {
                // if(tipo === 1){
                    this.principal = data.report.data,
                    this.totalRows = this.principal.length,
                    this.total = data.report.total,
                    this.desde = data.report.from,
                    this.hasta = data.report.to,
                    this.cargando = false
                    // this.setMakeExcel()
                // }else if(tipo === 2){
                //     this.principal = data.data,
                //     this.totalRows = this.principal.length,
                //     this.total = data.total,
                //     this.desde = data.from,
                //     this.hasta = data.to,
                //     this.cargando = false
                    // this.setMakeExcel()
                // }
            },
            */
            setInvoice: function (data) {
                this.previacorreo = true;
                this.invoice = data;
                this.reciveEmail = []
                this.listTerceros();
                let valordata = data
                let pasandoCorreoTerceros = {}
                if(this.selected != 6){
                    this.customers.forEach(function(element){
                    if(valordata.receiver.idReceptor == element.documento){
                            pasandoCorreoTerceros = element.emailEnvio
                        }      
                    })
                }
                this.reciveEmail = pasandoCorreoTerceros;
                if(this.reciveEmail.length > 0){
                    this.mostraremail = false;
                }else{
                    this.mostraremail = true;
                }
            },
            listTerceros: function() {
            axios
                .post(process.env.VUE_APP_API_URL + "terceros/listar/1", {
                token: this.$store.getters.userToken,
                page: this.currentPageTerceros,
                order: this.ordenTerceros
                })
                .then(response =>(
                    this.customers = response.data
                ))
                .catch(error => (
                console.log(error)
                ))
            },
            makeExcel: function () {
                let lista = [];
                this.principal2.forEach(function(value, key) {
                    let data = {};
                    data.Item = key;
                    data.Serie = value.serie;
                    data.Numero = value.numero;
                    data.FechaEmision = value.fechaEmision;
                    data.Receptor = value.idReceptor + '-' + value.receiver.razonSocial;
                    data.Moneda = value.tipoMoneda;
                    data.MontoTotalImpuestos = value.montoTotalImpuestos;
                    data.TotalVentaInafecta = value.totalVentaInafecta;
                    data.TotalVentaExonerada = value.totalVentaExonerada;
                    data.TotalVentaGratuita = value.totalVentaGratuita;
                    data.TotalVentaExportacion = value.totalVentaExportacion;
                    data.TotalIgv = value.sumatoriaIgv;
                    data.TotalVentaGravada = value.totalVentaGravada;
                    data.ImporteTotal = value.importeTotal;
                    if(value.emitido === 1){
                        data.Estado = "Emitido";
                    }
                    if(value.baja === 1){
                        data.Baja = "Si";
                    }else{
                        data.Baja = "No";
                    }
                    lista.push(data);
                });
            this.json_data = lista; 
            if(this.json_data.length > 0){
                this.responseExportExcel = true
            }
            },
            downloadReportExcel: function() {
                let date1 = this.$moment(this.f1).startOf('day').format('YYYY-MM-DD HH:mm:ss');
                let date2 = this.$moment(this.f2).endOf('day').format('YYYY-MM-DD HH:mm:ss');
                let file = '';
                let tag = document.createElement('i');
                tag.classList.add('fa','fa-spin', 'fa-spinner');
                let name = this.titleexcelrango +' '+ date1 + '-' + date2 + '.xlsx';
                this.loadingexcelreport = true;
                this.$swal({
                    title: 'Procesando Reporte',
                    content: tag,
                    icon: 'info',
                    buttons: false,
                    dangerMode: false
                });
                axios
                .post(process.env.VUE_APP_API_URL + this.rutaexcelrango, {
                    token: this.$store.getters.userToken,               
                    f1: date1,
                    f2: date2
                })
                .then(response => {
                file = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'+ response.data.base64;
                this.loadingexcelreport = false;
                download(file, name,'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                this.$swal.close()
                this.f1='',
                this.f2=''
                })
                .catch(error => { console.log(error)})
            },
            estadoEmision: function (value) {
                this.spinoff = true;
                axios
                .post(process.env.VUE_APP_API_URL + 'documento/motivorechazo', {
                    token: this.$store.getters.userToken,
                    serie: value.serie,
                    numero: value.numero,
                    tipo: '01'
                })
                .then(response => {
                    this.descripcionRechazo = response.data.msg.descripcion;
                    this.spinoff = false
                })
                .catch(error => {
                    this.$snotify.error(error.response.data, 'Error');
                    this.motivoRechazo = false;
                    this.spinoff = false
                })
            },
            preBaja: function (value) {
                let id = this.identificadorDocumento(value)
                this.modal = true;
                this.itembaja = [];
                this.documentoItemBaja.serie = value.serie;
                this.documentoItemBaja.numero = value.numero;
                this.documentoItemBaja.idReceptor = value.idReceptor;
                this.documentoItemBaja.razonSocial = value.receiver.razonSocial;
                this.docBaja.descripcion = 'DE BAJA';
                this.docBaja.serie = value.serie;
                this.docBaja.numero = value.numero;
                if(value.idFactura)
                {
                    this.docBaja.tipoComprobante = '01'
                }
                else if(value.idBoleta)
                {
                    this.docBaja.tipoComprobante = '03'
                }
                else if(value.idNotaCredito)
                {
                    this.docBaja.tipoComprobante = '07'
                }
                else if(value.idNotaDebito)
                {
                    this.docBaja.tipoComprobante = '08'
                }
                this.itembaja.push(this.docBaja);
                this.date = value.fechaEmision

                this.bolBajaSerie = value.serie;
                this.bolBajaNume = value.numero
            },
            sendBaja: function () { 
                let packagebaja = {};
                //let id = this.identificadorDocumento();
                switch(this.selectorDocumento){
                    case 1: 
                        packagebaja.token = this.$store.getters.userToken;
                        packagebaja.fechaEmisionDocs = this.$moment(this.date).format('YYYY-MM-DD');
                        packagebaja.items = this.itembaja;
                        break;
                    case 2: 
                        packagebaja.token = this.$store.getters.userToken;
                        packagebaja.serie = this.itembaja[0].serie;
                        packagebaja.numero = this.itembaja[0].numero;
                        //packagebaja.serie = this.bolBajaSerie;
                        //packagebaja.numero = this.bolBajaNume;
                        break;
                }
                this.loading2 = true;
                if(this.rutabaja !== ''){
                    axios
                    .post(process.env.VUE_APP_API_URL + this.rutabaja, packagebaja)
                    .then(response => {
                        this.loading2 = false;
                        this.modal = false;
                        this.listInvoice(1);
                        this.initValuesBaja();
                        this.$snotify.success(response.data.msg, 'Éxito')
                    })
                    .catch((error) => {
                        this.loading2 = false;
                        this.modal = false;
                        this.initValuesBaja();
                        this.$snotify.error(error.response.data.response, 'Error')
                    })
                }else{
                    this.$snotify.warning('Ups! Hubo un error, comuniquese con el area tecnica!','Cuidado')
                }
            },
            initValuesBaja: function() {
                this.documentoItemBaja.serie = '';
                this.documentoItemBaja.numero = '';
                this.documentoItemBaja.idReceptor = '';
                this.documentoItemBaja.razonSocial = '';
                this.docBaja.descripcion = 'DE BAJA';
                this.docBaja.serie = '';
                this.docBaja.numero = '';
                this.docBaja.tipoComprobante = '01';
                this.itembaja = []
            },
            borrarCorreo(index){
            this.reciveEmail.splice(index, 1)
                if(this.reciveEmail.length > 0){
                    this.mostraremail = false;
                }else{
                    this.mostraremail = true;
                }
            },
            enviarEmail: function(data) {
                for (let i = 0; i < this.reciveEmail.length; i++) {
                    this.reciveEmail[i] + ","
                }
                let cadena = this.reciveEmail.join(",");
                if(this.recipients !=''){
                    this.sendMail(data);  
                }  
                let id;
                id = this.identificadorDocumento(data);
                let rutaactual;
                this.previacorreo = true;
                this.sendcorreo = true;
                this.emitidorecibido === 0 ? rutaactual = this.rutamail: rutaactual = this.rutarecibidasmail;
                axios
                .post(process.env.VUE_APP_API_URL + rutaactual, {
                    token: this.$store.getters.userToken,
                    id: id,
                    mail: cadena
                    })
                .then(
                    response => ((
                    this.previacorreo = false),
                    (this.sendcorreo = false),
                    this.alertaenvio(response.data.msg)
                    ))
                .catch(
                    error => (
                    (this.previacorreo = false),
                    (this.sendcorreo = false),
                    this.$snotify.error(error.response.data.response, "Error") 
                ));
            },
            alertaenvio(data){
                if(this.recipients == ''){
                    this.$snotify.success(data, "Exito")
                }
            },
            send_message(data) {
                if(this.numeroWhatsApp && this.numeroWhatsApp.trim() !== ''){
                    if(this.numeroWhatsApp.length == 9){
                        let documento
                        const url = 'https://micomprobante.facturaonline.pe/s/pkey-'
                        const {
                            idEmisor,
                            serie,
                            numero,
                            idReceptor,
                            importeTotal
                        } = data
                        if(this.selected == '1'){
                            documento = '01'; //FACTURA
                        }else if(this.selected == '2'){
                            documento = '03';  //BOLETA
                        }
                        const mensaje = 'Comprobante' + ' ' + data.serie +'-'+ data.numero + ' ' + 'Emitido a través de TELEMOVILPERU.COM'
                        const cadena = `${idEmisor}|${documento}|${serie}|${numero}|${idReceptor}|${importeTotal}`
                        const text = `${url}.${btoa(cadena)}+${mensaje}`
                        window.open(`https://wa.me/+51${this.numeroWhatsApp}?text=${text}`, '_blank')
                    }else{
                        this.$snotify.warning("DEBE INGRESAR 9 DIGITOS")
                    }
                }else{
                    this.$snotify.warning("DEBE INGRESAR INFORMACION")
                }
            },
        }
    }
</script>

<style>
    .sup{
        margin-bottom: -25px;
    }
    .reportesheader{
        padding: 0;
        margin: 0;
    }
    .reporteOpciones{
        margin-left: -10px;
        width: 160px;
    }
    .btnremove{
        color: red;
        font-size: 18px;
        padding: 7px;
        height: 25px;
        width: 5px;
        margin-right: 5px;
        margin-top: -5px;
    }
    .titlefilter{
        padding: 0;
        margin: 3px 0 0;
    }
    .filtropersonalizado{
        height: 21px;
    }
    .badgepersonalizado{
        height: 27px;
    }
</style>